"use client";

import TripResultsTable from "../results/TripResultsTable";
import EmissionsComparison from "../results/EmissionsComparison";
import { TripResult } from "../../types/trip.types";
import VehicleResultsTable from "../results/VehicleResultsTable";
import { Result } from "@/types/result.types";

interface ResultsPanelProps {
  tripResult: TripResult | null;
  results: Result[];
  loading: boolean;
  setEmissionsLoaded: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  resultsRef: React.RefObject<HTMLDivElement | null>;
  costEntered: boolean;
  currency?: string;
}

export default function ResultsPanel({
  tripResult,
  results,
  loading,
  setEmissionsLoaded,
  resultsRef,
  costEntered,
  currency,
}: ResultsPanelProps) {
  const emissionCategories = [
    "Food", 
    "Travel", 
    // "Appliance"
  ];

  if (!tripResult && !loading) return null;

  return (
    <div ref={resultsRef}>
      {tripResult && 
        <TripResultsTable 
          trip={tripResult} 
          loading={loading} 
          onLoaded={() => {}} 
        />
      }

      {results.length > 0 && (
        <>
          <VehicleResultsTable
            results={results}
            costEntered={costEntered}
            currency={currency}
            loading={loading}
            onLoaded={() => {}}
          />

          <section className="emissions-comparison-section">
            <h2>Emissions Comparison</h2>
            {loading ? (
              <div className="emissions-comparison-loading">
                <div aria-label="Results Section Spinner" className="spinner" />
                <p className="text-white text-center">
                  This can sometimes take a few minutes...
                </p>
              </div>
            ) : (
              <>
                {results.length > 0 &&
                  emissionCategories.map((category) => (
                    <EmissionsComparison
                      key={category}
                      results={results}
                      column="category"
                      filter={category}
                      onLoaded={() =>
                        setEmissionsLoaded((prev) => ({ ...prev, [category]: true }))
                      }
                    />
                  ))}
              </>
            )}
          </section>
        </>
      )}
    </div>
  );
}
